import React from 'react';
import { RoutePermittedRole } from '../../@crema/constants/AppEnums';

const MonitorComponent = React.lazy(
    () => import('../../modules/monitor/MonitorComponent'),
);
const Companies = React.lazy(() => import('../../modules/Companies'));
const CompanyDetails = React.lazy(
    () => import('../../modules/Companies/CompanyDetails'),
);
const AddCompany = React.lazy(
    () => import('../../modules/Companies/AddEditCompany/AddCompany'),
);
const EditCompany = React.lazy(
    () => import('../../modules/Companies/AddEditCompany/EditCompany'),
);
const EditDesignation = React.lazy(
    () =>
        import(
            '../../modules/Designations/AddEditDesignation/EditDesignations'
        ),
);
const AddDesignation = React.lazy(
    () =>
        import('../../modules/Designations/AddEditDesignation/AddDesignations'),
);
const Designations = React.lazy(() => import('../../modules/Designations'));
const DesignationDetails = React.lazy(
    () => import('../../modules/Designations/DesignationDetails'),
);
const DesignationBulkUploadResult = React.lazy(
    () => import('../../modules/Designations/BulkUploadResult'),
);
const DesignationBulkUploadBatches = React.lazy(
    () => import('../../modules/Designations/BulkUploadBatches'),
);
const EditDepartment = React.lazy(
    () => import('../../modules/Departments/AddEditDepartment/EditDepartments'),
);
const AddDepartment = React.lazy(
    () => import('../../modules/Departments/AddEditDepartment/AddDepartments'),
);
const Departments = React.lazy(() => import('../../modules/Departments'));
const DepartmentDetails = React.lazy(
    () => import('../../modules/Departments/DepartmentDetails'),
);
const DepartmentBulkUploadResult = React.lazy(
    () => import('../../modules/Departments/BulkUploadResult'),
);
const DepartmentBulkUploadBatches = React.lazy(
    () => import('../../modules/Departments/BulkUploadBatches'),
);
const EditZone = React.lazy(
    () => import('../../modules/Zone/AddEditZone/EditZone'),
);
const AddZone = React.lazy(
    () => import('../../modules/Zone/AddEditZone/AddZone'),
);
const Zone = React.lazy(() => import('../../modules/Zone'));
const ZoneDetails = React.lazy(() => import('../../modules/Zone/ZoneDetails'));
const EditMSISDN = React.lazy(
    () => import('../../modules/Msisdns/AddEditMsisdn/EditMsisdns'),
);
const AddMsisdn = React.lazy(
    () => import('../../modules/Msisdns/AddEditMsisdn/AddMsisdns'),
);
const Msisdns = React.lazy(() => import('../../modules/Msisdns'));
const MsisdnDetails = React.lazy(
    () => import('../../modules/Msisdns/MsisdnDetails'),
);
const MsisdnBulkUploadResult = React.lazy(
    () => import('../../modules/Msisdns/BulkUploadResult'),
);
const MsisdnBulkUploadBatches = React.lazy(
    () => import('../../modules/Msisdns/BulkUploadBatches'),
);
const EditTask = React.lazy(
    () => import('../../modules/Tasks/AddEditTask/EditTasks'),
);
const AddTask = React.lazy(
    () => import('../../modules/Tasks/AddEditTask/AddTasks'),
);
const Tasks = React.lazy(() => import('../../modules/Tasks'));

const AssignTask = React.lazy(
    () => import('../../modules/Tasks/AssignTask/AssignTasks'),
);

const Roles = React.lazy(() => import('../../modules/Roles'));

const Poi = React.lazy(() => import('../../modules/poi'));
const PoiCreate = React.lazy(() => import('../../modules/poi/PoiCreate'));
const PoiEdit = React.lazy(() => import('../../modules/poi/PoiEdit'));
const PoiAssign = React.lazy(() => import('../../modules/poi/PoiAssign'));
const PoiAssignList = React.lazy(
    () => import('../../modules/poi/PoiAssignList'),
);
const Billings = React.lazy(() => import('../../modules/LbsBilling'));
const BillingDetails = React.lazy(
    () => import('../../modules/LbsBilling/LbsBillingDetails'),
);
const EditUser = React.lazy(
    () => import('../../modules/Users/AddEditUser/EditUsers'),
);
const AddUser = React.lazy(
    () => import('../../modules/Users/AddEditUser/AddUsers'),
);
const Users = React.lazy(() => import('../../modules/Users'));
const UserDetails = React.lazy(() => import('../../modules/Users/UserDetails'));
const UserBulkUploadResult = React.lazy(
    () => import('../../modules/Users/BulkUploadResult'),
);
const UserBulkUploadBatches = React.lazy(
    () => import('../../modules/Users/BulkUploadBatches'),
);
const Attendances = React.lazy(() => import('../../modules/Attendences'));

const Reports = React.lazy(() => import('../../modules/Reports'));
const DueInvoice = React.lazy(() => import('../../modules/DueInvoice'));

const ChangePassword = React.lazy(
    () => import('../../modules/account/MyProfile/ChangePassword'),
);

const TaskAssignListPage = React.lazy(
    () => import('../../modules/Tasks/AssignTask/List/TaskAssignListPage'),
);

export const appsConfig = [
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: ['/monitor'],
        element: <MonitorComponent />,
    },
    {
        permittedRole: RoutePermittedRole.CompanyAdmin,
        path: '/company/list',
        element: <Companies />,
    },
    {
        permittedRole: RoutePermittedRole.CompanyAdmin,
        path: '/company-details/:id',
        element: <CompanyDetails />,
    },
    {
        permittedRole: RoutePermittedRole.SuperAdmin,
        path: '/company/add',
        element: <AddCompany />,
    },
    {
        permittedRole: RoutePermittedRole.SuperAdmin,
        path: '/company-details/edit/:id',
        element: <EditCompany />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/designation/list',
        element: <Designations />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/designation-details/:id',
        element: <DesignationDetails />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/designation/bulk-upload-result/:batchId',
        element: <DesignationBulkUploadResult />,
    },
    {
        permittedRole: [RoutePermittedRole.SuperAdmin, RoutePermittedRole.CompanyAdmin],
        path: '/designation/bulk-upload-batches',
        element: <DesignationBulkUploadBatches />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/designation/add',
        element: <AddDesignation />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/designation-details/edit/:id',
        element: <EditDesignation />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/department/list',
        element: <Departments />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/department-details/:id',
        element: <DepartmentDetails />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
        ],
        path: '/department/add',
        element: <AddDepartment />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/department-details/edit/:id',
        element: <EditDepartment />,
    },
    {
        permittedRole: [RoutePermittedRole.SuperAdmin, RoutePermittedRole.CompanyAdmin, RoutePermittedRole.DepartmentAdmin],
        path: '/department/bulk-upload-result/:batchId',
        element: <DepartmentBulkUploadResult />,
    },
    {
        permittedRole: [RoutePermittedRole.SuperAdmin, RoutePermittedRole.CompanyAdmin],
        path: '/department/bulk-upload-batches',
        element: <DepartmentBulkUploadBatches />,
    },
    {
        permittedRole: RoutePermittedRole.ZoneAdmin,
        path: '/zone/list',
        element: <Zone />,
    },
    {
        permittedRole: RoutePermittedRole.ZoneAdmin,
        path: '/zone-details/:id',
        element: <ZoneDetails />,
    },
    {
        permittedRole: RoutePermittedRole.CompanyAdmin,
        path: '/zone/add',
        element: <AddZone />,
    },
    {
        permittedRole: RoutePermittedRole.ZoneAdmin,
        path: '/zone-details/edit/:id',
        element: <EditZone />,
    },

    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/msisdn/list',
        element: <Msisdns />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/msisdn-details/:id',
        element: <MsisdnDetails />,
    },
    {
        permittedRole: RoutePermittedRole.SuperAdmin,
        path: '/msisdn/add',
        element: <AddMsisdn />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/msisdn-details/edit/:id',
        element: <EditMSISDN />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/msisdn/bulk-upload-result/:batchId',
        element: <MsisdnBulkUploadResult />,
    },
    {
        permittedRole: RoutePermittedRole.SuperAdmin,
        path: '/msisdn/bulk-upload-batches',
        element: <MsisdnBulkUploadBatches />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/task/list',
        element: <Tasks />,
    },

    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/task/add',
        element: <AddTask />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/task-details/edit/:id',
        element: <EditTask />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/task-details/assign/:id',
        element: <AssignTask />,
    },
    {
        permittedRole: RoutePermittedRole.SuperAdmin,
        path: '/role/list',
        element: <Roles />,
    },

    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/poi-edit/:id',
        element: <PoiEdit />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/poi',
        element: <Poi />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/poi-create',
        element: <PoiCreate />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/poi-assign/:id',
        element: <PoiAssign />,
    },

    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/poi-assign/list',
        element: <PoiAssignList />,
    },

    {
        permittedRole: RoutePermittedRole.CompanyAdmin,
        path: '/billing/list',
        element: <Billings />,
    },
    {
        permittedRole: RoutePermittedRole.CompanyAdmin,
        path: '/billing-details/:id',
        element: <BillingDetails />,
    },
    {
        permittedRole: RoutePermittedRole.CompanyAdmin,
        path: '/user/list',
        element: <Users />,
    },
    {
        permittedRole: RoutePermittedRole.CompanyAdmin,
        path: '/user-details/:id',
        element: <UserDetails />,
    },
    {
        permittedRole: RoutePermittedRole.SuperAdmin,
        path: '/user/add',
        element: <AddUser />,
    },
    {
        permittedRole: RoutePermittedRole.SuperAdmin,
        path: '/user-details/edit/:id',
        element: <EditUser />,
    },
    {
        permittedRole: RoutePermittedRole.CompanyAdmin,
        path: '/user/bulk-upload-result/:batchId',
        element: <UserBulkUploadResult />,
    },
    {
        permittedRole: RoutePermittedRole.SuperAdmin,
        path: '/user/bulk-upload-batches',
        element: <UserBulkUploadBatches />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: ['/attendance/list'],
        element: <Attendances />,
    },
    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/reports',
        element: <Reports />,
    },

    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/due-invoice',
        element: <DueInvoice />,
    },

    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/change-password',
        element: <ChangePassword />,
    },

    {
        permittedRole: [
            RoutePermittedRole.SuperAdmin,
            RoutePermittedRole.CompanyAdmin,
            RoutePermittedRole.ZoneAdmin,
            RoutePermittedRole.DepartmentAdmin,
        ],
        path: '/task-assign-list',
        element: <TaskAssignListPage />,
    },
];
